module.exports = __webpack_public_path__ + "img/溯源查证@2x.952cf6ed.png";